import axios from 'axios'

import { PER_PAGE_MAX } from '@/constants/pagination'

const state = {
  productPriceList: null,
  loadingProdPrice: ''
}
const getters = {
  productPriceList: (state) => state.productPriceList,
  loadingProdPrice: (state) => state.loadingProdPrice
}

const actions = {
  async fetchProdPrice({ commit, dispatch }, { effectiveDate }) {
    let filters = {}
    if (effectiveDate) {
      filters = { price_date: { type: 'date', value: effectiveDate } }
    }

    commit('SET_LOADING_PROD_PRICE', 'prod-price-list')
    let { error, data = [] } = await dispatch(
      'fetch',
      {
        endpoint: 'pricing/',
        parameters: {
          limit: PER_PAGE_MAX,
          offset: 0,
          sort_by: '',
          ascending: false
        },
        filters
      },
      { root: true }
    )
    commit('SET_LOADING_PROD_PRICE', '')

    if (error) {
      const messagePrefix = 'Error while loading Product Price list! '
      dispatch('showError', { error, messagePrefix })
      return 'error'
    }

    commit('SET_PRODUCT_PRICE_LIST', data)
    return data
  },
  async createProdPrice(
    { rootGetters, commit, dispatch },
    { payload, productName }
  ) {
    const URI = `${rootGetters.baseUrl}pricing/`
    commit('SET_LOADING_PROD_PRICE', 'create')

    try {
      const res = await axios.post(URI, payload)
      dispatch(
        'showMessage',
        `New Product Price created successfuly! ${productName || ''}`
      )
      return res.data
    } catch (error) {
      const messagePrefix = 'Create Product Price Error! '
      dispatch('showError', { error, messagePrefix })
      return 'error'
    } finally {
      commit('SET_LOADING_PROD_PRICE', '')
    }
  },
  async updateProdPrice(
    { rootGetters, commit, dispatch },
    { payload, productName }
  ) {
    const URI = `${rootGetters.baseUrl}pricing/${payload.id}`
    commit('SET_LOADING_PROD_PRICE', `update-${payload.id}`)

    try {
      const res = await axios.patch(URI, payload)

      dispatch(
        'showMessage',
        `Product Price updated successfuly! ${productName || ''}`
      )

      return res.data
    } catch (error) {
      const messagePrefix = 'Update Product Price Error! '
      dispatch('showError', { error, messagePrefix })
      return 'error'
    } finally {
      commit('SET_LOADING_PROD_PRICE', '')
    }
  },

  async deleteProdPrice({ rootGetters, commit, dispatch }, { payload }) {
    const URI = `${rootGetters.baseUrl}pricing/${payload.id}`

    commit('SET_LOADING_PROD_PRICE', `delete-${payload.id}`)

    try {
      const res = await axios.delete(URI)

      dispatch(
        'showMessage',
        `Product Price deleted successfully! ${payload.product || ''}`
      )

      return res.data || 'success'
    } catch (error) {
      const messagePrefix = 'Delete Product Price Error'
      dispatch('showError', { error, messagePrefix })
      return 'error'
    } finally {
      commit('SET_LOADING_PROD_PRICE', '')
    }
  },

  async batchCreateProdPrice({ rootGetters, commit, dispatch }, { payload }) {
    const URI = `${rootGetters.baseUrl}pricing/batch_create/`
    commit('SET_LOADING_PROD_PRICE', 'batch-create')

    try {
      const res = await axios.post(URI, payload)

      const count = payload?.length || 0
      dispatch('showMessage', `${count} Product Prices created successfully!`)

      return res.data
    } catch (error) {
      const messagePrefix = 'Batch Create Product Price Error! '
      dispatch('showError', { error, messagePrefix })
      return 'error'
    } finally {
      commit('SET_LOADING_PROD_PRICE', '')
    }
  },

  async batchUpdateProdPrice({ rootGetters, commit, dispatch }, { payload }) {
    const URI = `${rootGetters.baseUrl}pricing/batch_update/`

    commit('SET_LOADING_PROD_PRICE', 'batch-update')

    try {
      const res = await axios.patch(URI, payload)

      const count = payload?.length || 0

      dispatch('showMessage', `${count} Product Prices updated successfully!`)

      return res.data
    } catch (error) {
      const messagePrefix = 'Batch Update Product Price Error!'
      dispatch('showError', { error, messagePrefix })
      return 'error'
    } finally {
      commit('SET_LOADING_PROD_PRICE', '')
    }
  }
}

const mutations = {
  SET_PRODUCT_PRICE_LIST: (state, payload) =>
    (state.productPriceList = payload),
  SET_LOADING_PROD_PRICE: (state, payload) => (state.loadingProdPrice = payload)
}

export default {
  state,
  getters,
  actions,
  mutations
}
